/**
 * Suspense-enabled hook for fetching category entries
 * Suspends during loading - use with <Suspense fallback={...}>
 */
import { useSuspenseQuery } from '@tanstack/react-query';
import { buildExploreEntry } from '../Model/Explore/ExploreEntryBuilder';
import { v1ParamsToV3Params } from '../Model/Explore/exploreV3Params';
import { useBackend } from './useBackend';

export function useCategoryEntriesSuspense(categoryId: string, categoryIdentifier: string) {
  const backend = useBackend();

  const { data } = useSuspenseQuery({
    queryKey: ['categoryEntriesV3', categoryId, categoryIdentifier],
    queryFn: async () => {
      // V3 filters entries by a single direct `parentId` (UUID). `category.id`
      // is the UUID; the identifier is a slug that V3 ignores, so the helper
      // picks the id out of the pair.
      const result = await backend.get(
        '/coach/explore/v3/entries',
        v1ParamsToV3Params({ rootCategories: [categoryIdentifier, categoryId], contentType: 'entry' }),
      );
      return (result ?? []).map((r: any) => buildExploreEntry(r));
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });

  return { entries: data ?? [] };
}
